import React, { useState, useEffect } from 'react';

export default function Login({ formUpdate, formData }) {
    const [focused, setFocused] = useState(null);
    return (
        <div className='form-group nm login-input-container' style={{ width: '65%', overflow: 'visible' }}>
            <input
                type='text'
                name='user'
                value={formData.user}
                onFocus={() => setFocused('user')}
                onBlur={() => setFocused(null)}
                onChange={formUpdate}
                placeholder='Username or Email'
                style={{ width: '100%', zIndex: focused === 'user' ? 2 : 1 }}
            />
            <input
                type='password'
                name='password'
                value={formData.password}
                onFocus={() => setFocused('password')}
                onBlur={() => setFocused(null)}
                onChange={formUpdate}
                placeholder='Password'
                style={{ width: '100%', zIndex: focused === 'password' ? 2 : 1 }}
            />
        </div>
    );
}